<div class="atividade-calendar">
	<sgt-calendar
		[(startDate)]="filter.diaPrazoInicial"
		[(endDate)]="filter.diaPrazoFinal"
		[(events)]="events"
		[eventTemplate]="eventTemplate"
		(eventClicked)="eventClicked($event)"
		(eventUpdated)="eventUpdated($event)"
		(datesChange)="onDatesChange()">
	</sgt-calendar>
</div>

<ng-template
	#eventTemplate
	let-event="event"
	let-atividade="eventMeta">
	<ng-template [ngIf]="atividade">
		<div class="cal-event-atividade">
			<div class="cal-event-atividade-sidebar">
				<input *ngIf="!atividade.conclusaoBloqueada" type="checkbox" [(ngModel)]="atividade.concluida" name="concluida"
				(ngModelChange)="updateConcluida(event, atividade)"
				onclick="event.stopPropagation()">
			</div>
			<div class="cal-event-atividade-content">
				<h6 class="cal-event-title" [ngStyle]="{'color': event.color?.primary}">
					#{{atividade.id}}
					<span *ngIf="isOrigemRetorno(atividade)">
						<i class="fas fa-retweet"></i>
					</span>
				</h6>
				<h6 class="cal-event-title" [ngStyle]="{'color': event.color?.primary}">
					<i [class]="atividade.tipo | atividadeTipoIcon" aria-hidden="true"></i>
					{{atividade.titulo}}
				</h6>
				<div *ngIf="atividade.horaPrazo">
					<i class="far fa-clock" aria-hidden="true"></i>
					{{atividade.horaPrazo | date: 'HH:mm'}}
				</div>

				<div class="cal-event-atividade-tags">
					<span *ngIf="atividade.quantidadeChecklistItens > 0" title="{{(atividade.quantidadeChecklistItensConcluidos ? atividade.quantidadeChecklistItensConcluidos : 0) | decimalFormat: 1:0:0}} item(ns) concluído(s) de {{(atividade.quantidadeChecklistItens ? atividade.quantidadeChecklistItens : 0) | decimalFormat: 1:0:0}} item(ns) no checklist">
						<i class="fas fa-tasks mr-1"></i>
						<span>{{(atividade.quantidadeChecklistItensConcluidos ? atividade.quantidadeChecklistItensConcluidos : 0) | decimalFormat: 1:0:0}}</span>
						<span>/</span>
						<span>{{(atividade.quantidadeChecklistItens ? atividade.quantidadeChecklistItens : 0) | decimalFormat: 1:0:0}}</span>
					</span>

					<span *ngIf="atividade.sinalizado">
						<i class="fas fa-flag atividade-flag atividade-flag-sinalizado" aria-hidden="true" title="Sinalizado"></i>
					</span>
					<span *ngIf="atividade.importante">
						<i class="fas fa-exclamation-triangle atividade-flag atividade-flag-importante" aria-hidden="true" title="Importante"></i>
					</span>
				</div>

				<div class="cal-event-text" *ngIf="atividade.comentario"
					[title]="atividade.comentario">
					{{atividade.comentario}}
				</div>

				<div>
					<sgt-avatar
            [settings]="{
              fullName: atividade.nomeUsuarioDestino,
              imageUrl: atividade.avatarUrlUsuarioDestino,
              size: 20,
              isShowLabelNameRight: true
            }">
					</sgt-avatar>
				</div>
			</div>
		</div>
	</ng-template>
</ng-template>
